import React from 'react';
import { MessageSquare, Mountain, Clock, FileText } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ProductContents() {
  const contents = [{
    icon: <MessageSquare className="w-6 h-6" data-id="element-128" />,
    title: 'Las 5 Frases de Acero',
    description: 'Respuestas cortas y neutrales que desarman cualquier burla al instante.'
  }, {
    icon: <Mountain className="w-6 h-6" data-id="element-129" />,
    title: 'La Postura de Roca',
    description: 'Lenguaje corporal simple para proyectar seguridad aunque tenga miedo.'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-130" />,
    title: 'El Plan de Acción 8 PM',
    description: 'La rutina nocturna para prepararlo mentalmente para el día siguiente.'
  }, {
    icon: <FileText className="w-6 h-6" data-id="element-131" />,
    title: 'Guion para hablar con la Seño',
    description: 'Qué decir (y qué no) en el colegio para que te tomen en serio.'
  }];
  return <section className="w-full py-24 px-6 max-w-5xl mx-auto" data-id="element-132">
      <FadeIn data-id="element-133">
        <h2 className="font-playfair text-3xl md:text-4xl text-center text-dark-coffee font-semibold mb-16" data-id="element-134">
          ¿Qué incluye el protocolo?
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-135">
        {contents.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-136">
            <div className="bg-beige rounded-2xl p-8 flex items-start gap-6 hover:bg-[#F0DDC0] transition-colors duration-300" data-id="element-137">
              <div className="p-3 bg-white rounded-xl text-warm-accent shadow-sm shrink-0" data-id="element-138">
                {item.icon}
              </div>
              <div data-id="element-139">
                <h3 className="font-playfair text-xl font-semibold text-dark-coffee mb-2" data-id="element-140">
                  {item.title}
                </h3>
                <p className="text-soft-brown leading-relaxed" data-id="element-141">
                  {item.description}
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}